import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import cn from 'classnames';

const PersonTeaserBlock = ({ className, name, title, photo, signature }) => {
  return (
    <div
      className={cn('person-teaser-block', {
        [className]: className,
      })}
    >
      {photo && (
        <div className="person-teaser-block__photo-holder">
          <Image {...photo} className="image_size_person-teaser-photo" />
        </div>
      )}
      <div className="person-teaser-block__content">
        {name && <strong className="person-teaser-block__name">{name}</strong>}
        {title && <span className="person-teaser-block__title">{title}</span>}
        {signature && (
          <Image
            {...signature}
            transform={Image.transforms.fit}
            className="person-teaser-block__signature image_size_person-teaser-signature"
          />
        )}
      </div>
    </div>
  );
};

PersonTeaserBlock.viewModelMeta = {
  className: 'ignore',
};

PersonTeaserBlock.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  photo: PropTypes.exact(Image.propTypes),
  signature: PropTypes.exact(Image.propTypes),
};

export default PersonTeaserBlock;
